import type { ReactNode } from 'react';

interface PageProps {
  title?: string;
  children: ReactNode;
}

/**
 * Контейнер страницы. Учитывает safe-area-insets и оставляет
 * место снизу для BottomNav.
 */
export function Page({ title, children }: PageProps): JSX.Element {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--tg-secondary-bg)',
        paddingTop: 'calc(var(--safe-top) + var(--space-md))',
        paddingBottom: 'calc(var(--safe-bottom) + 80px)',
      }}
    >
      {title && (
        <h1
          style={{
            fontSize: 'var(--font-xl)',
            fontWeight: 700,
            margin: '0 0 var(--space-lg)',
            padding: '0 var(--space-lg)',
            color: 'var(--tg-text)',
          }}
        >
          {title}
        </h1>
      )}
      {children}
    </div>
  );
}
